var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpecjalne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6599 4.66091C14.1623 3.79941 13.4945 3.04827 12.6971 2.4534C11.8997 1.85853 10.9895 1.43238 10.0219 1.20093C9.05438 0.969486 8.04975 0.937611 7.06949 1.10725C6.08923 1.27689 5.15377 1.64448 4.3203 2.18759C1.14939 4.24703 0.0749677 8.44469 1.86171 11.7768C2.70914 13.3668 4.11519 14.5869 5.80883 15.2018C7.54162 15.8326 8.97663 17.0872 9.89871 18.6842C10.2007 19.2075 10.6983 19.5892 11.2819 19.7456C11.8654 19.9019 12.4872 19.8201 13.0104 19.518L15.6019 18.0218C15.8698 17.8671 16.1046 17.6612 16.2929 17.4158C16.4813 17.1703 16.6194 16.8902 16.6995 16.5914C16.7796 16.2926 16.8 15.981 16.7596 15.6743C16.7192 15.3675 16.6188 15.0718 16.4642 14.8039C15.5532 13.2021 15.2278 11.3334 15.5436 9.51802C15.8226 7.84548 15.5101 6.128 14.6599 4.66091Z",
    stroke: "#F8AA9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.206 17.5234L16.2809 17.6532C16.4274 17.907 16.5225 18.1871 16.5607 18.4776C16.5989 18.7681 16.5796 19.0633 16.5038 19.3463C16.4279 19.6294 16.2971 19.8946 16.1188 20.1271C15.9404 20.3596 15.7179 20.5546 15.4642 20.7012C14.9515 20.9969 14.3424 21.0769 13.7708 20.9236C13.1991 20.7703 12.7118 20.3963 12.4158 19.8837L12.3516 19.7724",
    stroke: "#F8AA9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51562 16.913L14.7506 15.5493",
    stroke: "#F8AA9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4531 18.1605L16.5183 17.0527",
    stroke: "#F8AA9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50781 16.0818L15.398 11.5264",
    stroke: "#F8AA9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4747 13.7914L8.54688 8.72021",
    stroke: "#F8AA9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54688 8.72046L9.39806 5.54395",
    stroke: "#F8AA9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07584 8.32497L6.81794 8.25647L5.28906 7.84619",
    stroke: "#F8AA9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecjalne);
export default __webpack_public_path__ + "static/media/specjalne.e63f44663d704aa5ac99d04b49e02b45.svg";
export { ForwardRef as ReactComponent };